import clsx from 'clsx';
import React from 'react';

const FormElement = ({ children, disabled, appearance, className, ...props }) => (
  <div
    disabled={disabled}
    className={clsx(
      'mb-4',
      {
        'flex items-center': appearance === 'row',
      },
      className,
    )}
    {...props}
  >
    {children}
  </div>
);

export default FormElement;
